/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  Grid,
} from '@material-ui/core';
import ErrorIcon from '@assets/images/ban_and_lock/error-icon.png';
import './UsernameForm.css';

function UsernameForm({
  handleNextScreen,
  usernameVal,
  changeTextColor,
  errorMessage,
  showErrorMessage,
  disableNextBtn,
}) {
  return (
    <Grid
      container
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <div>
        <input
          placeholder='Enter username'
          value={usernameVal}
          onChange={(e) => changeTextColor(e)}
          className='field-form-style'
          id='username-form-id'
        />
        {showErrorMessage && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginLeft: 5,
              marginTop: 10,
              minWidth: 300,
              maxWidth: 300,
            }}
          >
            <img src={ErrorIcon} alt='error-icon' width={15} height={15} />
            <p
              style={{
                fontFamily: 'CircularXX-Book',
                fontSize: 12,
                color: '#E32B2B',
                marginLeft: 10,
                textAlign: 'left',
              }}
            >
              {errorMessage}
            </p>
          </div>
        )}
        <button type='button' onClick={handleNextScreen} id='next-btn' className='next-btn-style' disabled={disableNextBtn}>Next</button>
      </div>
    </Grid>
  );
}

export default UsernameForm;
